import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MatTableModule } from '@angular/material/table';
import { ToggleMenuButtonModule } from '../toggle-menu-button/toggle-menu-button.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatRowKeyboardSelectionModule } from '../../core/directive/mat-row-keyboard-selection.module';
import { MatLineModule, MatRippleModule } from '@angular/material/core';
import { DateRangeSelectionModule } from '../date-range-selection/date-range-selection.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AskForAutogehenTimeComponent } from './ask-for-autogehen-time.component';

@NgModule({
  declarations: [AskForAutogehenTimeComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTableModule,
    TranslateModule.forChild({}),
    MatRippleModule,
    MatRowKeyboardSelectionModule,
    ToggleMenuButtonModule,
    DateRangeSelectionModule,
    MatLineModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
  ],
  exports: [AskForAutogehenTimeComponent],
  providers: [],
})
export class AskForAutogehenTimeModule {}
